import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "blog",
  class: "view"
}
const _hoisted_2 = {
  key: 0,
  id: "featuredArticle"
}
const _hoisted_3 = { class: "img-wrap" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "intro" }
const _hoisted_6 = { class: "bottom" }
const _hoisted_7 = { class: "author-date" }
const _hoisted_8 = {
  key: 1,
  class: "topWrap"
}
const _hoisted_9 = {
  key: 0,
  id: "featuredNews"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("from mt7rk "),
  /*#__PURE__*/_createElementVNode("span", null, "من متحرك")
], -1)
const _hoisted_11 = { class: "box-shadow img-wrap bc-red" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "intro" }
const _hoisted_14 = { class: "bottom" }
const _hoisted_15 = { class: "author-date" }
const _hoisted_16 = { class: "newsWrap box-shadow right reversed desktop" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("news "),
  /*#__PURE__*/_createElementVNode("span", null, "من الاخبار")
], -1)
const _hoisted_18 = { id: "newsScroll" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "img-wrap" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 2,
  id: "contentWrap"
}
const _hoisted_23 = {
  key: 3,
  class: "topWrap"
}
const _hoisted_24 = { class: "newsWrap box-shadow right reversed mobile" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("news "),
  /*#__PURE__*/_createElementVNode("span", null, "من الاخبار")
], -1)
const _hoisted_26 = { id: "newsScroll" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "img-wrap" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 4,
  id: "communityWrap"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h3", { class: "flex space-between" }, [
  /*#__PURE__*/_createTextVNode("community "),
  /*#__PURE__*/_createElementVNode("span", null, "من المحركين")
], -1)
const _hoisted_32 = {
  key: 5,
  id: "moreWrap"
}

export function render(_ctx, _cache) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Carousel = _resolveComponent("Carousel")
  const _component_Grid = _resolveComponent("Grid")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.posts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.blog.custom_fields.featured_article[0].custom_fields.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.blog.custom_fields.featured_article[0].custom_fields.image.url,
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.goToBlog(_ctx.blog.custom_fields.featured_article[0])))
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.goToBlog(_ctx.blog.custom_fields.featured_article[0]))),
            class: _normalizeClass('info box-shadow '+_ctx.blog.custom_fields.featured_article[0].custom_fields.language)
          }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.blog.custom_fields.featured_article[0].post_title), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.blog.custom_fields.featured_article[0].custom_fields.intro_text), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", {
                class: "category",
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.goToCat(decodeURIComponent(_ctx.blog.custom_fields.featured_article[0].category[0].slug))), ["stop"]))
              }, _toDisplayString(_ctx.blog.custom_fields.featured_article[0].category[0].name), 1),
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString((_ctx.blog.custom_fields.featured_article[0].custom_fields.author ? _ctx.blog.custom_fields.featured_article[0].custom_fields.author.post_title : '')) + " - ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.blog.custom_fields.featured_article[0].custom_fields.date), 1)
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.posts && _ctx.posts.news && _ctx.posts.news.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.blog && _ctx.blog.custom_fields.featured_news)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    src: _ctx.blog.custom_fields.featured_news[0].custom_fields.image.url,
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.goToBlog(_ctx.blog.custom_fields.featured_news[0])))
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(['info-box', (_ctx.blog.custom_fields.featured_news[0].custom_fields.language ? _ctx.blog.custom_fields.featured_news[0].custom_fields.language : '')])
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", {
                      onClick: _cache[4] || (_cache[4] = $event => (_ctx.goToBlog(_ctx.blog.custom_fields.featured_news[0])))
                    }, _toDisplayString(_ctx.blog.custom_fields.featured_news[0].post_title), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.blog.custom_fields.featured_news[0].custom_fields.intro_text), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, [
                        _createTextVNode(_toDisplayString((_ctx.blog.custom_fields.featured_news[0].custom_fields.author ? _ctx.blog.custom_fields.featured_news[0].custom_fields.author.post_title : '')) + " - ", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.blog.custom_fields.featured_news[0].custom_fields.date), 1)
                      ]),
                      _createElementVNode("p", {
                        class: "category",
                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.goToCat(decodeURIComponent(_ctx.blog.custom_fields.featured_news[0].category[0].slug))))
                      }, _toDisplayString(_ctx.blog.custom_fields.featured_news[0].category[0].name), 1)
                    ])
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news, (post) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["news-post", [(post.custom_fields.language ? post.custom_fields.language : '')]]),
                    onClick: $event => (_ctx.goToNews(post))
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: post.custom_fields.image.sizes.thumbnail
                      }, null, 8, _hoisted_21)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", null, _toDisplayString(post.post_title), 1)
                    ])
                  ], 10, _hoisted_19))
                }), 256)),
                _createVNode(_component_router_link, { to: "/news" }, {
                  default: _withCtx(() => [
                    (_ctx.LoadJSON)
                      ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                          key: 0,
                          ref: "loadNews",
                          class: "loadMore",
                          animationData: _ctx.LoadJSON,
                          height: 115,
                          width: 294,
                          loop: true,
                          autoPlay: false,
                          onMouseover: _cache[6] || (_cache[6] = $event => (_ctx.overAnim('loadNews'))),
                          onMouseout: _cache[7] || (_cache[7] = $event => (_ctx.outAnim('loadNews')))
                        }, null, 8, ["animationData"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.posts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_ctx.posts.content)
            ? (_openBlock(), _createBlock(_component_Carousel, {
                key: 0,
                posts: _ctx.posts.content,
                featured: _ctx.blog.custom_fields,
                exclude: _ctx.blog.custom_fields.featured_news[0].ID
              }, null, 8, ["posts", "featured", "exclude"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, { to: "/content" }, {
            default: _withCtx(() => [
              (_ctx.LoadJSON)
                ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                    key: 0,
                    ref: "loadCon",
                    class: "loadMore",
                    animationData: _ctx.LoadJSON,
                    height: 115,
                    width: 294,
                    loop: true,
                    autoPlay: false,
                    onMouseover: _cache[8] || (_cache[8] = $event => (_ctx.overAnim('loadCon'))),
                    onMouseout: _cache[9] || (_cache[9] = $event => (_ctx.outAnim('loadCon')))
                  }, null, 8, ["animationData"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.news.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", null, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts.news, (post) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["news-post", [(post.custom_fields.language ? post.custom_fields.language : '')]]),
                    onClick: $event => (_ctx.goToNews(post))
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("img", {
                        src: post.custom_fields.image.sizes.thumbnail
                      }, null, 8, _hoisted_29)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", null, _toDisplayString(post.post_title), 1)
                    ])
                  ], 10, _hoisted_27))
                }), 256)),
                _createVNode(_component_router_link, { to: "/news" }, {
                  default: _withCtx(() => [
                    (_ctx.LoadJSON)
                      ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                          key: 0,
                          ref: "newsLoadMob",
                          class: "loadMore",
                          animationData: _ctx.LoadJSON,
                          height: 115,
                          width: 294,
                          loop: true,
                          autoPlay: false,
                          onMouseover: _cache[10] || (_cache[10] = $event => (_ctx.overAnim('newsLoadMob'))),
                          onMouseout: _cache[11] || (_cache[11] = $event => (_ctx.outAnim('newsLoadMob')))
                        }, null, 8, ["animationData"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.posts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _hoisted_31,
          (_ctx.posts && _ctx.posts.community.length > 0)
            ? (_openBlock(), _createBlock(_component_Grid, {
                key: 0,
                posts: _ctx.posts.community
              }, null, 8, ["posts"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, { to: "/community" }, {
            default: _withCtx(() => [
              (_ctx.LoadJSON)
                ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                    key: 0,
                    ref: "loadCom",
                    class: "loadMore",
                    animationData: _ctx.LoadJSON,
                    height: 115,
                    width: 294,
                    loop: true,
                    autoPlay: false,
                    onMouseover: _cache[12] || (_cache[12] = $event => (_ctx.overAnim('loadCom'))),
                    onMouseout: _cache[13] || (_cache[13] = $event => (_ctx.outAnim('loadCom')))
                  }, null, 8, ["animationData"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.posts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32))
      : _createCommentVNode("", true)
  ]))
}